import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchProductContentGrid} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ProductContentRawRow} from 'types';

const domain = rootDomain.createDomain('aggregateContentTableDomain');

export const Gate = createGate<{markingCode: string; gtin: string | null}>(
    'AggregateContentTableGate',
);

export const fetchDataFx = domain.createEffect({
    name: 'fetchOrderListFx',
    handler: fetchProductContentGrid,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    tableStateChanged,
} = createGridTableModel({domain, Gate});

export const data$ = domain.createStore<ProductContentRawRow[]>([]);

export const state$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
});
